require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-apetlon.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-apetlon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-apetlon!./.cache/json/betreuungseinrichtungen-neusiedl-apetlon.json
// module id = 944
// module chunks = 231608221292675